import React, { useEffect } from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';
import Animated, {
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

export interface ShineOverlayProps extends ViewProps {
  /* Animation duration, default is 750 */
  duration?: number;

  /* Play the animation in reverse mod */
  reverse?: boolean;
}

export function ShineOverlay({ duration, children, reverse }: ShineOverlayProps) {
  const start: `${number}%` = reverse ? '100%' : '0%';
  const end: `${number}%` = reverse ? '0%' : '100%';
  const animation = useSharedValue(start);

  useEffect(() => {
    animation.set(start);
    animation.set(withRepeat(withTiming(end, { duration: duration || 750 }), -1));
    return () => {
      cancelAnimation(animation);
    };
  }, [animation, duration, end, start]);

  const animatedStyle = useAnimatedStyle(() => ({ left: animation.get() }));

  return (
    <View>
      {children}
      <Animated.View style={[styles.shine, animatedStyle]} />
    </View>
  );
}

const styles = StyleSheet.create({
  shine: {
    backgroundColor: '#ffffff',
    height: '100%',
    opacity: 0.4,
    position: 'absolute',
    width: 30,
  },
});
